module.exports = __webpack_public_path__ + "f6a0e8109e85dd5af6b9bad41b1041b4.svg";